<div #container class="flex gap-3 border-b border-gray-200">
	@if (displayButton) {
		<button
			(click)="onScrollContainer('left')"
			data-toggle="tab"
			role="tab"
			aria-label="Prev"
			class="carousel-navigation swiper-button-prev !m-auto !hidden sm:!block !py-2 !mt-6 after:-ml-1 after:content-['prev']"
		></button>
	}
	<div
		#scrollContainer
		class="flex items-center justify-between px-6 -mx-5 overflow-scroll sm:px-0 sm:mx-0 hide-scrollbar scroll-smooth"
	>
		<ul class="flex gap-6 whitespace-nowrap" aria-label="Tabs">
			@for (item of navigationItems(); track item; let i = $index) {
				<li
					#elements
					[id]="'item-' + i"
					class="inline-block list-none cursor-pointer whitespace-nowrap"
					role="presentation"
				>
					<a
						class="inline-flex items-center py-6 text-base font-medium text-gray-500 border-b-2 border-transparent cursor-pointer tab-hover"
						[ngClass]="{
							'tab-selected': i === selectedIndex,
						}"
						(click)="selectIndex.emit(i); selectedIndex = i"
						data-toggle="tab"
					>
						{{ item | ucEntities }}
					</a>
				</li>
			}
		</ul>
	</div>
	@if (displayButton) {
		<button
			(click)="onScrollContainer('right')"
			data-toggle="tab"
			role="tab"
			aria-label="Next"
			class="carousel-navigation swiper-button-next !m-auto !hidden sm:!block !py-2 !mt-6 after:-ml-[3px] after:content-['next']"
		></button>
	}
</div>
